import { formatAWSDate } from '../../../helpers/functions';
import { CreateStrategyAssetInput, FormValues } from '../types';
import { FormikProps } from 'formik';
import { ConnectionTypeEnum, CurrencyCodeEnum } from '../../../constants/enums';

export function prepareWalletInput(
  profileId: string,
  connectionType: ConnectionTypeEnum,
  formik: FormikProps<FormValues>,
  reportingCurrency: CurrencyCodeEnum
) {
  const { strategyId } = formik.values;

  const purchasedAt = formatAWSDate(
    formik.values.purchasedAt ? new Date(formik.values.purchasedAt) : new Date()
  );

  const result: CreateStrategyAssetInput[] =
    formik.values.selectedWalletAssets.map(
      ({ name, categoryId, unit, value }) => ({
        alert: false,
        bank: '',
        connectionType,
        currency: reportingCurrency,
        currentPrice: value,
        entryPrice: value,
        inspirationSource: '',
        name,
        profileId,
        purchasedAt,
        strategyAssetCategoryId: categoryId,
        strategyAssetTargets: [],
        strategyId,
        unit,
      })
    );

  return result;
}
